import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import {
  MEETING_SCHEDULE_LIST,
  USER_LIST_DROPDOWN,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  CITY_LIST_DROPDOWN,
  CHAPTER_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
} from "../../routes/routes";
import { NoDataFound, Pagination, hasRole } from "../../components/Utils";
import { AttendanceFlagCells, AttendanceFlagHeaders } from "../../components/common/AttendanceFlags";
import { PAGINATE } from "../../constant/constant";
import Loader from "../../components/common/Loader";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_red.css";
import moment from "moment";
import { Link } from "react-router-dom";
import StickyTable from "../../components/common/StickyTable";
import { useForumReportDateRange } from "../../hooks/useForumReportDateRange";
const AttendanceList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({});
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [cityOptions, setCityOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [userOptions, setUserOptions] = useState({});
  const [showClearBtn, setShowClearBtn] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [paginator, setPaginator] = useState({});
  const [detailModal, setDetailModal] = useState(false);
  const [detailData, setDetailData] = useState({});

  const refFlatpickr = useRef(null);
  const selectStateRef = useRef(null);
  const selectCityRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);
  const selectMemberRef = useRef(null);

  const auth_user = JSON.parse(localStorage.getItem("user"));
  const isRegionAdmin = auth_user?.user_type === 2 ? 1 : 0;
  const isChapterAdmin = auth_user?.user_type === 3 ? 1 : 0;

  const statusOptions = [
    { value: "pending", label: "Pending" },
    { value: "absent", label: "Absent" },
    { value: "present", label: "Present" },
    { value: "substitute", label: "Substitute" },
    { value: "medical", label: "Medical" },
  ];

  const handleStateClear = () => {
    if (selectStateRef.current) selectStateRef.current.clearValue();
    if (selectCityRef.current) selectCityRef.current.clearValue();
    if (selectRegionRef.current) selectRegionRef.current.clearValue();
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
    if (selectMemberRef.current) selectMemberRef.current.clearValue();
  };

  const handleCityClear = () => {
    if (selectCityRef.current) selectCityRef.current.clearValue();
    if (selectRegionRef.current) selectRegionRef.current.clearValue();
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
    if (selectMemberRef.current) selectMemberRef.current.clearValue();
  };

  const handleRegionClear = () => {
    if (selectRegionRef.current) selectRegionRef.current.clearValue();
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
    if (selectMemberRef.current) selectMemberRef.current.clearValue();
  };

  const handleChapterClear = () => {
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
    if (selectMemberRef.current) selectMemberRef.current.clearValue();
    if (refFlatpickr.current && refFlatpickr.current.flatpickr) {
      refFlatpickr.current.flatpickr.clear();
      setShowClearBtn(false);
    }
  };

  const handleMemberClear = () => {
    if (selectMemberRef.current) selectMemberRef.current.clearValue();
  };

  const handleCalendarClick = () => {
    if (refFlatpickr.current?.flatpickr) {
      refFlatpickr.current.flatpickr.open();
    }
  };

  const handleDateRangeClear = () => {
    setShowClearBtn(false);
    if (refFlatpickr.current?.flatpickr) {
      refFlatpickr.current.flatpickr.setDate([]);
    }
    setFilter({ ...filter, from_date: "", to_date: "" });
  };

  const {
    from_date: forumFromDate,
    to_date: forumToDate,
    ready: forumRangeReady,
  } = useForumReportDateRange(filter?.chapter_id);

  useEffect(() => {
    if (!forumRangeReady) return;
    if (!forumFromDate || !forumToDate) {
      setFilter((prev) => ({
        ...(Array.isArray(prev) ? {} : prev),
        from_date: "",
        to_date: "",
      }));
      if (refFlatpickr.current?.flatpickr) {
        refFlatpickr.current.flatpickr.clear();
        setShowClearBtn(false);
      }
      return;
    }
    setFilter((prev) => ({
      ...(Array.isArray(prev) ? {} : prev),
      from_date: forumFromDate,
      to_date: forumToDate,
    }));
    setShowClearBtn(true);
    setTimeout(() => {
      if (refFlatpickr.current?.flatpickr) {
        refFlatpickr.current.flatpickr.setDate([forumFromDate, forumToDate]);
      }
    }, 0);
  }, [forumRangeReady, forumFromDate, forumToDate]);

  // Fetch meetings list & dropdowns
  useEffect(() => {
    setLoading(true);
    axios
      .get(MEETING_SCHEDULE_LIST, {
        params: { type: PAGINATE, page, perPage, isAdmin: 1, ...filter },
      })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setData(response.data.data.schedules || []);
          setPaginator({
            prev: response.data.data.prev != null && response.data.data.prev !== "",
            next: response.data.data.next != null && response.data.data.next !== "",
            total: response.data.data.total,
            current: response.data.data.current_page,
            last: response.data.data.last_page,
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });

    const fetchDropdowns = async () => {
      try {
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        setCountryOptions(countryResponse.data.data);

        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: { ...filter },
        });
        setStateOptions(stateResponse.data.data);

        const cityResponse = await axios.get(CITY_LIST_DROPDOWN, {
          params: { ...filter },
        });
        setCityOptions(cityResponse.data.data);

        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: { ...filter },
        });
        setRegionOptions(regionResponse.data.data);

        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: { ...filter },
        });
        setChapterOptions(chapterResponse.data.data);

        const userResponse = await axios.get(USER_LIST_DROPDOWN, {
          params: {
            ...filter,
            exclude_other_region_chapter_users: 1,
          },
        });
        setUserOptions(userResponse.data.data);
      } catch (error) {
        console.error("Error fetching dropdowns:", error);
      }
    };
    fetchDropdowns();
  }, [filter, page, perPage]);

  const getColSpanCount = () => {
    let count = 9; // S.NO, Member, Date, Time, Attended, Substitute, Medical, Attachment, Action
    if (hasRole([1])) count += 1; // Country
    if (hasRole([1, 6])) count += 1; // State
    if (hasRole([1, 6, 7])) count += 1; // City
    if (hasRole([1, 6, 7, 8])) count += 1; // Region
    if (hasRole([1, 6, 7, 8, 2])) count += 1; // Circle
    return count;
  };

  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Attendance</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>Dashboard</Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Attendance</span>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-grow-1">
        <div className="card icard sticky-table-card">
          <div className="container-fluid f_containter">
            <div className="row mb-4">
              {hasRole([1]) && (
                <div className="mb-3 col-md-3">
                  <label className="form-label" htmlFor="country_id">
                    Country
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="country_id"
                    isClearable
                    options={countryOptions}
                    onChange={(selected) => {
                      handleStateClear();
                      setFilter({
                        ...filter,
                        country_id: selected?.value,
                        state_id: null,
                        city_id: null,
                        region_id: null,
                        chapter_id: null,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6]) && (
                <div className="mb-3 col-md-3">
                  <label className="form-label" htmlFor="state_id">
                    State
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    ref={selectStateRef}
                    name="state_id"
                    isClearable
                    options={stateOptions}
                    onChange={(selected) => {
                      handleCityClear();
                      setFilter({
                        ...filter,
                        state_id: selected?.value,
                        city_id: null,
                        region_id: null,
                        chapter_id: null,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6, 7]) && (
                <div className="col-md-3 mb-3">
                  <label className="form-label" htmlFor="city_id">
                    City
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    ref={selectCityRef}
                    name="city_id"
                    isClearable
                    options={cityOptions}
                    onChange={(selected) => {
                      handleRegionClear();
                      setFilter({
                        ...filter,
                        city_id: selected?.value,
                        region_id: null,
                        chapter_id: null,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6, 7, 8]) && (
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="region_id">
                      Region
                    </label>
                    <Select
                      ref={selectRegionRef}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      name="region_id"
                      isClearable
                      options={regionOptions}
                      onChange={(selected) => {
                        handleChapterClear();
                        setFilter({
                          ...filter,
                          region_id: selected?.value,
                          chapter_id: null,
                          user_id: null,
                        });
                      }}
                    />
                  </div>
                </div>
              )}

              {hasRole([1, 6, 7, 8, 2]) && (
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="chapter_id">
                      Circle
                    </label>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      ref={selectChapterRef}
                      name="chapter_id"
                      isClearable
                      options={chapterOptions}
                      onChange={(selected) => {
                        handleMemberClear();
                        setFilter({
                          ...filter,
                          chapter_id: selected?.value,
                          user_id: null,
                        });
                      }}
                    />
                  </div>
                </div>
              )}

              <div className="col-md-3">
                <div className="mb-3">
                  <label className="form-label" htmlFor="user_id">
                    Member
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    ref={selectMemberRef}
                    name="user_id"
                    isClearable
                    options={userOptions}
                    onChange={(selected) =>
                      setFilter({ ...filter, user_id: selected?.value })
                    }
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="mb-3">
                  <label className="form-label" htmlFor="meeting_status">
                    Status
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="meeting_status"
                    isClearable
                    options={statusOptions}
                    onChange={(selected) =>
                      setFilter({
                        ...filter,
                        meeting_status:
                          selected !== null && selected !== undefined
                            ? selected.value
                            : null,
                      })
                    }
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="mb-3 dateRangeDiv">
                  <label className="form-label">Date Range</label>
                  <div className="datepicker_wrapper">
                    <div className="datepicker">
                      <Flatpickr
                        ref={refFlatpickr}
                        className="form-control"
                        options={{
                          mode: "range",
                          dateFormat: "d/m/Y",
                          onChange: (selected) => {
                            setShowClearBtn(true);
                            if (
                              selected[0] !== undefined &&
                              selected[1] !== undefined &&
                              selected[1] !== ""
                            ) {
                              setFilter({
                                ...filter,
                                from_date: moment(selected[0]).format("DD/MM/YYYY"),
                                to_date: moment(selected[1]).format("DD/MM/YYYY"),
                              });
                            }
                          },
                        }}
                        placeholder="Select date range"
                      />
                      {showClearBtn && (
                        <button
                          className="border-0 clearDateRangeBtn"
                          data-bs-toggle="tooltip"
                          data-bs-offset="0,4"
                          data-bs-placement="top"
                          data-bs-html="true"
                          title="Clear"
                          data-bs-original-title="Clear"
                          onClick={handleDateRangeClear}
                        >
                          <i className="bx bx-x"></i>
                        </button>
                      )}
                    </div>
                    <div className="cal_icon" onClick={handleCalendarClick}>
                      <span className="input-group-text calendar-icon"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Meetings Table */}
          <StickyTable refreshDeps={[data, loading]}>
            <table className="table table-striped itable">
              <thead>
                <tr>
                  <th>S.NO</th>
                  <th>Member</th>
                  <th>Meeting Date</th>
                  <th>Meeting Time</th>
                  <AttendanceFlagHeaders />
                  {hasRole([1]) && <th>Country</th>}
                  {hasRole([1, 6]) && <th>State</th>}
                  {hasRole([1, 6, 7]) && <th>City</th>}
                  {hasRole([1, 6, 7, 8]) && <th>Region</th>}
                  {hasRole([1, 6, 7, 8, 2]) && <th>Circle</th>}
                  <th style={{ textAlign: "center" }}>Action</th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader loading={loading} colspan={String(getColSpanCount())} />
                ) : data.length > 0 ? (
                  data.map((meeting) => (
                    <tr key={meeting.id || meeting.sno}>
                      <td>{meeting.sno}</td>
                      <td>
                        <span className="table_img pr-2">
                          <img src={meeting?.user_profile_image} alt="icon" />
                        </span>
                        {meeting?.user_name}
                      </td>
                      <td>{meeting.meeting_date}</td>
                      <td>{meeting.meeting_time}</td>
                      <AttendanceFlagCells
                        row={meeting}
                        onDone={() => setFilter((prev) => ({ ...prev }))}
                      />
                      {hasRole([1]) && <td>{meeting.country_name}</td>}
                      {hasRole([1, 6]) && <td>{meeting.state_name}</td>}
                      {hasRole([1, 6, 7]) && <td>{meeting.city_name}</td>}
                      {hasRole([1, 6, 7, 8]) && <td>{meeting.region_name}</td>}
                      {hasRole([1, 6, 7, 8, 2]) && (
                        <td>{meeting.chapter_name}</td>
                      )}
                      <td style={{ textAlign: "center" }}>
                        <button
                          className="badge bg-label-info me-1 border-0"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="View"
                          data-bs-original-title="View"
                          onClick={() => {
                            setDetailData(meeting);
                            setDetailModal(true);
                          }}
                        >
                          <i className="bx bx-show"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoDataFound colspan={String(getColSpanCount())} message="No Data Found" />
                )}
              </tbody>
            </table>
          </StickyTable>
          <Pagination paginator={paginator} page={(no) => setPage(no)} perPage={perPage} setPerPage={setPerPage} />
        </div>
      </div>

      <Modal
        show={detailModal}
        size="lg"
        centered
        onHide={() => setDetailModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="modal_title1">Attendance Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body py-0">
            <div className="row">
              {[
                ["Member", detailData.user_name],
                ["Meeting Date", detailData.meeting_date],
                ["Meeting Time", detailData.meeting_time],
                ["Country", detailData.country_name],
                ["State", detailData.state_name],
                ["City", detailData.city_name],
                ["Region", detailData.region_name],
                ["Circle", detailData.chapter_name],
                [
                  "Attendance",
                  Number(detailData.is_medical_leave) === 1
                    ? "Medical leave"
                    : Number(detailData.is_substitute) === 1
                    ? "Substitute"
                    : Number(detailData.meeting_status) === 1
                    ? "Present"
                    : Number(detailData.meeting_status) === 2
                    ? "Absent"
                    : "Not marked",
                ],
                ["Substitute", Number(detailData.is_substitute) === 1 ? "Yes" : "No"],
                ["Substitute Name", Number(detailData.is_substitute) === 1 ? detailData.substitute_name : "-"],
                ["Substitute Mobile", Number(detailData.is_substitute) === 1 ? detailData.substitute_mobile : "-"],
                ["Medical", Number(detailData.is_medical_leave) === 1 ? "Yes" : "No"],
              ].map(([label, value]) => (
                <div className="col-md-6" key={label}>
                  <div className="mb-4">
                    <label className="form-label m-0">{label}</label>
                    <span className="d-block font-weight-600">{value || "-"}</span>
                  </div>
                </div>
              ))}
              <div className="col-12">
                <div className="mb-2">
                  <label className="form-label m-0">Attachment</label>
                  {detailData.attachment && detailData.attachment.url ? (
                    <div className="mt-2">
                      {String(detailData.attachment.file_name || "").match(/\.(jpg|jpeg|png|webp|gif)$/i) ? (
                        <a href={detailData.attachment.url} target="_blank" rel="noreferrer">
                          <img
                            src={detailData.attachment.url}
                            alt="Attachment"
                            style={{ maxWidth: 220, maxHeight: 160, borderRadius: 8, display: "block" }}
                          />
                        </a>
                      ) : (
                        <a
                          href={detailData.attachment.url}
                          target="_blank"
                          rel="noreferrer"
                          className="d-inline-flex align-items-center justify-content-center text-danger text-decoration-none"
                          style={{ width: 72, height: 72, borderRadius: 8, background: "#fde8ea", fontSize: 36 }}
                          title="Open PDF"
                        >
                          <i className="bx bxs-file-pdf"></i>
                        </a>
                      )}
                    </div>
                  ) : (
                    <span className="d-block font-weight-600">-</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary ibutton" onClick={() => setDetailModal(false)}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AttendanceList;
